<template>
  <v-container
    id="company-worlds-list"
    tag="section"
  >
    <!-- Bouton de retour vers la liste des entreprises -->
    <v-row>
      <v-btn
        text
        @click="routeToCompaniesList()"
      >
        <v-icon left>
          mdi-chevron-left
        </v-icon>
        Retour
      </v-btn>
    </v-row>

    <!-- Toast de réussite ou d'échec -->
    <!--<v-snackbar
      v-model="msg.alert"
      top
      shaped
      :color="msg.type"
      :timeout="msg.timeout"
    >
      <v-icon left>
        {{ msg.icon }}
      </v-icon>
      {{ msg.msg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="msg.alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>-->
    <v-row justify="center">
      <v-col cols="8">
        <timed-alert
          :display="msg.alert"
          :msg="msg.msg"
          :type="msg.type"
        />
      </v-col>
    </v-row>

    <base-material-card
      color="primary"
      icon="mdi-briefcase-variant"
      inline
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <div class="display-2 font-weight-light">
          <v-icon left>
            mdi-earth
          </v-icon>
          {{ title }}
        </div>
      </template>

      <!-- **************** ***
      ****      MODALS      ***
      **** **************** -->
      <!-- Modal de création de monde -->
      <template v-slot:after-heading>
        <v-dialog
          v-model="addDialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              outlined
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Ajouter un monde
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline secondary--text">Nouveau monde</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <!-- Formulaire -->
                <v-form
                  ref="addForm"
                  v-model="addIsValid"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="addedItem.world"
                        :items="worlds"
                        item-value="id"
                        item-text="title"
                        :rules="[rules.required]"
                        label="Nom du monde..."
                        counter="150"
                        prepend-icon="mdi-earth"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="addedItem.smiles"
                        type="number"
                        :rules="[rules.required]"
                        label="Nombre de sourires requis..."
                        prepend-icon="mdi-emoticon-excited-outline"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="success darken-1"
                text
                :disabled="!addIsValid"
                @click="addItem()"
              >
                Créer
              </v-btn>
              <v-btn
                color="error darken-1"
                text
                @click="addDialog = false"
              >
                Annuler
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- Modal de modification de monde -->
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="350px"
      >
        <v-card>
          <v-card-title>
            <span class="headline secondary--text">Modification du monde<br><b>{{ editedItem.title }}</b></span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <!-- Formulaire -->
              <v-form
                ref="editForm"
                v-model="editIsValid"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.smilesNeededToUnlock"
                      type="number"
                      :rules="[rules.required]"
                      label="Nombre de sourires requis..."
                      prepend-icon="mdi-emoticon-excited-outline"
                    />
                  </v-col>
                </v-row>
                <v-row
                  justify="center"
                  class="title text-uppercase"
                >
                  <v-col
                    cols="12"
                  >
                    <v-row justify="center">
                      Valeur habituelle
                    </v-row>
                    <v-row
                      justify="center"
                      class="secondary--text"
                    >
                      {{ editedItem.title }} : {{ editedItem.defaultSmiles }}
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              :disabled="!editIsValid"
              @click="editItem()"
            >
              Modifier
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="editDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de suppression de monde -->
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="320"
      >
        <v-card>
          <v-card-title class="headline">
            Êtes-vous sûr de vouloir supprimer le monde
            <div class="container">
              <span class="secondary--text">
                <b>{{ deletedItem.title }}</b>
              </span>
              ?
            </div>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              @click="deleteItem()"
            >
              Supprimer
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="deleteDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- **************** ***
      ****      TABLE      ***
      **** **************** -->
      <!-- Champ de recherche dans la table -->
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Rechercher"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['position']"
        :sort-desc="[false]"
        :loading="isLoading"
        multi-sort
      >
        <!-- Réorganisation de la table pour permettre le draggable -->
        <template v-slot:body="props">
          <draggable
            v-model="props.items"
            tag="tbody"
            @change="handleDragChange(props.items)"
          >
            <!-- Description d'une ligne -->
            <tr
              v-for="(item, index) in props.items"
              :key="index"
            >
              <td>
                <!-- Affichage de l'icône de drag and drop -->
                <v-row justify="center">
                  <v-icon>
                    mdi-sort-variant
                  </v-icon>
                </v-row>
              </td>
              <td> {{ item.id }} </td>
              <td> {{ item.title }} </td>
              <td> {{ item.smilesNeededToUnlock }} </td>
              <td> {{ item.position }} </td>
              <td>
                <!-- Définition de l'action d'édition -->
                <v-row justify="center">
                  <v-icon
                    class="success--text"
                    @click="prepareEditItem(item, 0)"
                  >
                    mdi-pencil
                  </v-icon>
                </v-row>
              </td>
              <td>
                <!-- Définition de l'action de suppression -->
                <v-row justify="center">
                  <v-icon
                    class="error--text"
                    @click="prepareDeleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </v-row>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import TimedAlert from '../alerts/TimedAlert.vue'
  import Draggable from 'vuedraggable'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'CompanyWorldsList',

    /* Sous-composants utilisés par ce composant */
    components: {
      TimedAlert,
      Draggable,
    },

    /* Paramètres */
    props: {
      idCompany: {
        type: String,
        default: undefined,
      },
      nameCompany: {
        type: String,
        default: undefined,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: () => ({
      isLoading: true,

      // Variables pour les formulaires de création / modification / suppression
      rules: {
        required: value => !!value || 'Ce champ ne peut être vide.',
      },

      worlds: [],
      addDialog: false,
      addIsValid: true,
      addedItem: {
        world: undefined,
        smiles: undefined,
      },

      editDialog: false,
      editIsValid: true,
      editedItem: {
        title: undefined,
        idCompany: undefined,
        id: undefined,
        smilesNeededToUnlock: undefined,
        defaultSmiles: undefined,
        position: undefined,
      },

      deleteDialog: false,
      deletedItem: {
        worldId: undefined,
      },

      // Message de réussite ou d'échec des actions
      msg: {
        alert: false,
        msg: '',
        timeout: 5000,
        type: 'success',
      },

      // Variables relatives au tableau de données
      headers: [
        {
          sortable: false,
          value: 'drag',
        },
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Nom',
          value: 'title',
        },
        {
          text: 'Nombre de sourires',
          value: 'smilesNeededToUnlock',
        },
        {
          sortable: false,
          text: 'Position',
          value: 'position',
        },
        {
          sortable: false,
          text: 'Éditer',
          value: 'edit',
        },
        {
          sortable: false,
          text: 'Supprimer',
          value: 'delete',
        },
      ],
      items: [],
      search: undefined,
    }),

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      title: function () {
        return 'Mondes ' +
          (this.isVowelIndex(this.nameCompany[0]) ? 'd\'' : 'de ') +
          this.nameCompany
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchAll()
    },

    /* Fonctions internes */
    methods: {
      // Récupération de toutes les données en base
      fetchAll: function () {
        if (!this.idCompany) {
          this.items = []
        } else {
          this.fetchWorldsByCompany(this.idCompany)
        }
        this.fetchWorlds()
      },

      // Modification de la position par drag & drop
      handleDragChange: function (items) {
        // On définie l'état en chargement
        this.isLoading = true
        items.map((item, index) => {
          // Mettre à jour uniquement les positions impactées
          const newPosition = index + 1
          if (item.position !== newPosition) {
            item.position = newPosition
            this.$Auth.httpRequest('post', 'api/companyworld/update', {
              worldId: item.worldId,
              companyId: item.companyId,
              position: newPosition,
              smilesNeededToUnlock: item.smilesNeededToUnlock,
            })
              .catch((/* error */) => {
                // Affichage de l'erreur
                this.setMsgError('Erreur lors de la modification du monde.')
                if (this.$Auth.isAdmin()) {
                  // console.log('Error in ' + this.$options.name + ' : ', error)
                }
              })
              .finally(() => {
                this.isLoading = false
                this.fetchAll()
              })
          }
        })
      },

      // State if the char is a vowel
      isVowelIndex: function (char) {
        const vowelsIndex = 'aeiouyAEIOUY'
        if (char.length === 1) {
          return vowelsIndex.indexOf(char) >= 0
        }
      },

      // Récupération des données de tous les mondes
      fetchWorlds: function () {
        this.$Auth.httpRequest('get', 'api/world/selectAll')
          .then(datas => {
            if (Array.isArray(datas.data) || datas.data.length > 0) {
              this.worlds = datas.data
            } else {
              this.worlds = []
            }
          })
          .catch((/* error */) => {
            this.worlds = []
            this.setMsgError('Une erreur est survenue lors de la récupération de la liste des mondes.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Récupération des données des mondes d'une entreprise
      fetchWorldsByCompany: function (idCompany) {
        this.$Auth.httpRequest(
          'get',
          'api/companyworld/selectWorldAndPositionForCompany?companyId=' +
            idCompany,
        )
          .then(datas => {
            if (Array.isArray(datas.data) || datas.data.length > 0) {
              this.items = datas.data
            } else {
              this.items = []
            }
          })
          .catch((/* error */) => {
            this.items = []
            this.setMsgError('Une erreur est survenue lors de la récupération des mondes.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.items.map((object, index) => {
              if (object.position !== index + 1) {
                object.position = index + 1
                this.$Auth.httpRequest('post', 'api/companyworld/update', {
                  worldId: object.worldId,
                  companyId: idCompany,
                  position: index + 1,
                  smilesNeededToUnlock: object.smilesNeededToUnlock,
                })
              }
            })
            this.isLoading = false
          })
      },

      // Route vers la page de la liste des entreprises
      routeToCompaniesList: function () {
        this.$router.push({ name: 'Companies List' })
      },

      /* ********************************* **
      /** Fonctions relatives aux messages **
      /** ******************************** */
      /* Setter de message de réussite */
      setMsgSuccess: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'success'
        this.msg.icon = 'mdi-checkbox-marked-circle-outline'
      },

      /* Setter de message d'échec */
      setMsgError: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'error'
        this.msg.icon = 'mdi-error-outline'
      },

      /* ******************************* **
      /** Fonctions d'ajout de monde **
      /** ****************************** */
      addItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.addDialog = false
        this.msg.alert = false

        // Ajout d'un monde
        this.$Auth.httpRequest('post', 'api/companyworld/insert', {
          companyId: this.idCompany,
          worldId: this.addedItem.world,
          position: this.items.length + 1,
          smilesNeededToUnlock: this.addedItem.smiles,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le monde a été ajouté avec succès.')

            // Réinitialisation des valeurs pour l'item ajouté
            this.addedItem.world = undefined
            this.addedItem.smiles = undefined
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de l\'ajout du monde.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.addForm.resetValidation()
            this.isLoading = false
            this.fetchAll()
          })
      },

      /* *************************************** **
      /** Fonctions de modification d'un monde **
      /** ************************************** */
      prepareEditItem: function (item, tab) {
        // Création du clone d'item
        // Ajout des sourires par défaut
        this.editedItem = {
          defaultSmiles: this.defaultSmiles(item.title),
          ...item,
        }
        this.editDialog = true
      },

      resetEditedItem: function () {
        return {
          title: undefined,
          idCompany: undefined,
          id: undefined,
          smilesNeededToUnlock: undefined,
          defaultSmiles: undefined,
          position: undefined,
        }
      },

      // Récupération du nombre de sourires par défaut pour le monde en paramètre
      defaultSmiles: function (title) {
        if (!this.worlds) {
          return undefined
        }
        const world = this.worlds.find(element => element.title === title)
        return !world ? undefined : world.smilesNeededToUnlockByDefault
      },

      editItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.editDialog = false
        this.msg.alert = false

        // Modification du monde
        this.$Auth.httpRequest('post', 'api/companyworld/update', {
          companyId: this.idCompany,
          worldId: this.editedItem.id,
          position: this.editedItem.position,
          smilesNeededToUnlock: this.editedItem.smilesNeededToUnlock,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le monde a été modifié avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la modification du monde.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.editForm.reset()
            this.editedItem = this.resetEditedItem()
            this.isLoading = false
            this.fetchAll()
          })
      },

      /* ************************************** **
      /** Fonctions de suppression du monde **
      /** ************************************* */
      prepareDeleteItem: function (item) {
        // Création du clone d'item
        this.deletedItem = { ...item }
        this.deleteDialog = true
      },

      deleteItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.deleteDialog = false
        this.msg.alert = false

        //  Suppression d'un monde
        this.$Auth.httpRequest(
          'delete',
          'api/companyworld/delete?companyId=' +
            this.idCompany +
            '&worldId=' +
            this.deletedItem.id,
        )
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le monde a été supprimé avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la suppression du monde.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
            this.fetchAll()
          })
      },
    },
  }
</script>
